export class EntityAuditEvent {
    constructor(
        public id?: number,
        public entityId?: number,
        public entityType?: string,
        public action?: string,
        public entityValue?: string,
        public commitVersion?: number,
        public modifiedBy?: string,
        public modifiedDate?: any,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/entity-audit-event/entity-audit-event.model.ts